<template>
  <t-modal
    :name="id"
    :variant="`confirmation`"
    :hideCloseButton="true"
    :disableBodyScroll="true"
    :escToClose="false"
    :clickToClose="false"
    ref="popup"
  >
    <div v-if="!isMailSent" class=" px-5 py-10">
      <div class="flex flex-col items-center">
        <div class="w-full flex justify-center">
          <img
            src="@/assets/icon/open-email.svg"
            alt="open-email"
            class="w-auto h-20 "
          />
        </div>
        <p class="font-bold text-xl">
          {{ $t('components.settingsManagement.profile.emailChange.headText') }}
        </p>
      </div>
      <p class="text-gray-600 mt-6 text-sm text-center">
        {{
          $t(
            'components.settingsManagement.profile.emailChange.descriptionText.click'
          )
        }}
        <span class="font-bold text-gray-900">{{
          $t(
            'components.settingsManagement.profile.emailChange.descriptionText.sendEmail'
          )
        }}</span>
        {{
          $t(
            'components.settingsManagement.profile.emailChange.descriptionText.below'
          )
        }}
        <span class="font-bold text-gray-600">{{ email }}</span>
        {{
          $t(
            'components.settingsManagement.profile.emailChange.descriptionText.with'
          )
        }}
      </p>
    </div>
    <div v-else class=" px-5 py-10">
      <div class="">
        <h1
          class="mt-16 mb-5 text-lg font-bold text-xl md:text-2xl text-center"
          style="color: #505458"
        >
          {{
            $t(
              'components.settingsManagement.profile.emailChange.descriptionText.enterCode'
            )
          }}
        </h1>
        <div class="text-center">
          <p class="text-gray-600 text-sm text-center">
            {{
              $t(
                'components.settingsManagement.profile.emailChange.descriptionText.toComplete'
              )
            }}
          </p>
          <p class="font-bold text-gray-900">{{ email }}</p>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <div class="relative py-5">
          <loading
            v-if="isLoading"
            :active="isLoading"
            :height="25"
            :opacity="0.5"
            :color="`#000`"
            :loader="`bars`"
            :is-full-page="false"
            :class="`outline-none`"
          />
          <otp-input
            @on-complete="onCompleteOTPHandler"
            @on-changed="onChangeOTPHandler"
            :digits="6"
            mode="separate"
            :isValid="isOtpValid"
          >
            <template #errorMessage>
              <div class="text-center mt-2">
                <p class="font-medium">{{ otpErrorMessage }}</p>
              </div>
            </template>
          </otp-input>
        </div>
      </div>

      <p class="text-center">
        {{
          $t(
            'components.settingsManagement.profile.emailChange.descriptionText.didNotGetCode'
          )
        }}
        <span
          class="text-blue-500 font-bold cursor-pointer"
          @click="executeAction('sendEmail')"
          >{{
            $t(
              'components.settingsManagement.profile.emailChange.descriptionText.resend'
            )
          }}</span
        >
      </p>
    </div>

    <section class="flex items-center py-4 px-4 mt-6 space-x-5 bg-gray-100">
      <anchor-button
        :variant="cancelButtonVariant"
        :class="`w-1/2`"
        @click="executeAction('cancel')"
      >
        {{ $t('components.stepNavigation.cancel') }}
      </anchor-button>
      <anchor-button
        v-if="!isMailSent"
        :variant="confirmButtonVariant"
        :class="`w-1/2`"
        :isLoading="isLoading"
        @click="executeAction('sendEmail')"
      >
        {{
          $t(
            'components.settingsManagement.profile.emailChange.descriptionText.sendEmail'
          )
        }}
      </anchor-button>
      <anchor-button
        v-if="isMailSent"
        :variant="confirmButtonVariant"
        :class="`w-1/2`"
        :isLoading="isLoading"
        @click="executeAction('verifyEmail')"
      >
        {{ $t('components.stepNavigation.submit') }}
      </anchor-button>
    </section>
  </t-modal>
</template>

<script>
import OtpInput from 'otp-input-vue2'
import xMan from '@/utils/xMan'
export default {
  name: 'EmailChange',
  components: {
    AnchorButton: () => import('@/components/form/AnchorButton.vue'),
    OtpInput,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    sendEmailURL: {
      type: String,
      required: true,
    },
    verifyEmailURL: {
      type: String,
      required: true,
    },
    cancelButtonText: {
      type: [String, Number],
      required: false,
      default: 'Cancel',
    },
    cancelButtonVariant: {
      type: String,
      required: false,
      default: 'secondary',
      validaotor(val) {
        return [
          'primary',
          'secondary',
          'success',
          'success-alt',
          'warning',
          'warning-alt',
          'disabled',
        ].includes(val)
      },
    },
    confirmButtonVariant: {
      type: String,
      required: false,
      default: 'primary',
      validaotor(val) {
        return [
          'primary',
          'secondary',
          'success',
          'success-alt',
          'warning',
          'warning-alt',
          'disabled',
        ].includes(val)
      },
    },
  },

  data: () => ({
    isLoading: false,
    isMailSent: false,
    isOtpValid: true,
    otpErrorMessage: '',
    otpCode: null,
  }),
  computed: {
    getSecretEmail() {
      return new xMan(this.email).asteriskify(7, 5)
    },
  },

  methods: {
    onCompleteOTPHandler(code) {
      this.otpCode = code
    },
    onChangeOTPHandler() {
      if (!this.isOtpValid) {
        this.isOtpValid = true
        this.otpErrorMessage = ''
      }
    },
    executeAction(type) {
      if (type === 'sendEmail' && this.isLoading === false) {
        this.isLoading = true
        const data = new FormData()
        data.append('email', this.email)
        this.$http
          .post(this.sendEmailURL, data)
          .then(() => {
            this.isMailSent = true
            this.$notify(
              {
                group: 'bottomRight',
                type: 'success',
                title: 'Success',
                text: 'Sent Email Successfully',
              },
              3000
            )
          })
          .catch((err) => {
            console.log('sentEmailErr', { err })
            this.$notify(
              {
                group: 'bottomRight',
                type: 'error',
                title: 'Failed',
                text: `${err.response}`,
              },
              5000
            )
          })
          .finally(() => (this.isLoading = false))
      }

      if (type === 'verifyEmail') {
        if (String(this.otpCode).length === 6) {
          this.isLoading = true
          const data = new FormData()
          data.append('code', this.otpCode)
          this.$http
            .post(this.verifyEmailURL, data)
            .then(() => {
              this.initData()
              this.$emit('success')
              this.$refs.popup.hide()
              this.$notify(
                {
                  group: 'generic',
                  type: 'success',
                  title: 'Success',
                  text: 'Update Successfully',
                },
                3000
              )
            })
            .catch((err) => {
              this.isOtpValid = false
              this.otpErrorMessage = err.response.data.message
              console.log('verifyEmailErr', { err })
            })
            .finally(() => {
              this.isLoading = false
              this.otpCode = null
              // this.initData()
            })
        }
      }

      if (type === 'cancel' && this.isLoading === false) {
        this.$refs.popup.hide()
        this.initData()
        this.$emit('cancel')
      }
    },
    initData() {
      this.isMailSent = false
      this.otpCode = null
      this.otpErrorMessage = ''
      this.isOtpValid = null
    },
  },
}
</script>

<style lang="scss" scoped></style>
